module.exports = __webpack_public_path__ + "static/media/blur-bg.75ba7ce5.jpg";